// Central blog post list — all internal, no external dependencies.

export const POSTS = [
  {
    slug: "downfall-of-g2-capterra-listing-sites-seo",
    categories: ["SEO", "Digital Marketing"],
    title: "The Downfall of G2, Capterra & Other Listing Sites on Google: What Really Happened to Software Review SEO?",
    excerpt:
      "For years, review aggregators owned the top of every software search. Then Google's updates gutted their traffic. Here's what actually happened — and what it means for B2B SEO.",
    date: "Sep 18, 2026",
    dateISO: "2026-09-18",
    readTime: "14 min read",
    accent: "#E63946",
    toneDark: false,
    featured: true,
  },
  {
    slug: "5-marketing-shifts-for-2026",
    categories: ["AI", "Digital Marketing"],
    title: "5 Marketing Shifts for 2026 That Break All the Old Rules",
    excerpt:
      "The ground is moving under our feet. Social clicks are disappearing, AI answers are replacing search, and the playbook needs a full rewrite.",
    date: "Dec 11, 2025",
    dateISO: "2025-12-11",
    readTime: "9 min read",
    accent: "#E63946",
    toneDark: false,
  },
  {
    slug: "agentic-ai-future",
    categories: ["AI"],
    title: "Agentic AI: The Future of Autonomous, Self-Driven Intelligence",
    excerpt:
      "Agentic AI moves beyond prompts and into autonomous workflows. What it is, how it works, and why B2B marketers should care.",
    date: "Oct 26, 2025",
    dateISO: "2025-10-26",
    readTime: "8 min read",
    accent: "#0A0A0A",
    toneDark: true,
  },
  {
    slug: "ai-digital-marketing-tools-2025",
    categories: ["Digital Marketing"],
    title: "25+ Best AI Digital Marketing Tools for 2025",
    excerpt:
      "A practical, field-tested guide to the AI tools that actually move the needle across content, ads, analytics and ops.",
    date: "Aug 24, 2025",
    dateISO: "2025-08-24",
    readTime: "12 min read",
    accent: "#E63946",
    toneDark: false,
  },
  {
    slug: "generative-ai-seo-guide-2025",
    categories: ["SEO"],
    title: "Generative AI SEO: How to Optimize Content for AI Search Engines",
    excerpt:
      "SGE, Copilot, Perplexity — the rules of visibility are being rewritten. Here's the 2025 playbook for getting found by AI.",
    date: "Jul 18, 2025",
    dateISO: "2025-07-18",
    readTime: "10 min read",
    accent: "#0A0A0A",
    toneDark: true,
  },
  {
    slug: "google-ads-performance-max-and-ai-max",
    categories: ["Google Ads"],
    title: "Maximizing B2B Success with Google Ads Performance Max & AI Max",
    excerpt:
      "PMax and AI Max aren't just consumer plays. A practical framework for wringing B2B pipeline out of automated campaigns.",
    date: "May 20, 2025",
    dateISO: "2025-05-20",
    readTime: "7 min read",
    accent: "#E63946",
    toneDark: false,
  },
  {
    slug: "digital-experience-platform-dxp",
    categories: ["Digital Marketing"],
    title: "Digital Experience Platform (DXP): The Future of Customer Engagement",
    excerpt:
      "What a DXP actually is, why it matters for enterprise B2B, and how to decide if your stack is ready for one.",
    date: "Jan 6, 2025",
    dateISO: "2025-01-06",
    readTime: "8 min read",
    accent: "#0A0A0A",
    toneDark: true,
  },
  {
    slug: "role-of-google-and-linkedin-ads-2025",
    categories: ["LinkedIn Ads", "Google Ads", "Digital Marketing"],
    title: "Google and LinkedIn Ads: Reimagining Digital Marketing in 2025",
    excerpt:
      "Google and LinkedIn Ads sit at the front of a dramatic B2B transformation. Here's how to use them together in 2025.",
    date: "Dec 14, 2024",
    dateISO: "2024-12-14",
    readTime: "9 min read",
    accent: "#E63946",
    toneDark: false,
  },
  {
    slug: "digital-marketing-trends-in-2025",
    categories: ["Digital Marketing"],
    title: "How Key Digital Marketing Trends in 2025 Will Shape Your Strategy",
    excerpt:
      "Digital marketing is undergoing a seismic shift. The trends that will redefine 2025 — and how to plan against them.",
    date: "Nov 7, 2024",
    dateISO: "2024-11-07",
    readTime: "8 min read",
    accent: "#0A0A0A",
    toneDark: true,
  },
  {
    slug: "lead-generation",
    categories: ["Lead Generation"],
    title: "Crafting Effective Lead Generation Campaigns for Diverse Business Sectors",
    excerpt:
      "Unlock the potential of your business by mastering lead generation — strategies that resonate across diverse sectors.",
    date: "Oct 11, 2024",
    dateISO: "2024-10-11",
    readTime: "7 min read",
    accent: "#E63946",
    toneDark: false,
  },
];

export const ALL_CATEGORIES = Array.from(
  new Set(POSTS.flatMap((p) => p.categories))
).sort();

export const getPost = (slug) => POSTS.find((p) => p.slug === slug) || null;
